/**
 * Error codes for the application
 * Format: E{number} - Description
 * 
 * Usage in code:
 * import { ERROR_CODES } from '../constants/errorCodes';
 * 
 * Example:
 * toast.error(`E1001: ${t('errors.something_went_wrong')}`);
 */

export const ERROR_CODES = {
  // Auth Saga Errors
  E1001: 'E1001', // Login function error
  E1002: 'E1002', // Logout function error
  E1003: 'E1003', // Connect wallet function error
  E1004: 'E1004', // Telegram sign function error
  E1005: 'E1005', // Fetch balance function error

  // Category Saga Errors
  E2001: 'E2001', // Fetch category details function error
  E2002: 'E2002', // Fetch all categories function error
  E2003: 'E2003', // Get custom category detail function error

  // Crypto Saga Errors
  E3001: 'E3001', // Verify BNB transaction function error
  E3002: 'E3002', // Verify MATIC transaction function error
  E3003: 'E3003', // BNB check balance function error
  E3004: 'E3004', // MATIC check balance function error
  E3005: 'E3005', // Purchase verify function error
  E3006: 'E3006', // Purchase interval verify function error
  E3007: 'E3007', // CMC conversion function error
  E3008: 'E3008', // BNB conversion function error

  // Game Saga Errors
  E4001: 'E4001', // Trigger events function error
  E4002: 'E4002', // Fetch game app data function error
  E4003: 'E4003', // Fetch leaderboard function error
  E4004: 'E4004', // Get dev details function error
  E4005: 'E4005', // App rating function error
  E4006: 'E4006', // Get achievements function error
  E4007: 'E4007', // Check game participation function error
  E4008: 'E4008', // Fetch game by tag function error
  E4009: 'E4009', // Get app product detail function error
  E4010: 'E4010', // Get app products function error
  E4011: 'E4011', // Get game user rated detail function error
  E4012: 'E4012', // Game purchase function error
  E4013: 'E4013', // Subtract score function error

  // Home Saga Errors
  E5001: 'E5001', // Load homepage data function error
  E5002: 'E5002', // Fetch section games function error
  E5003: 'E5003', // Fetch home data function error
  E5004: 'E5004'  // Fetch home featured function error
};

export const getErrorMessage = (code) => {
  return `${code}: ${ERROR_CODES[code] || 'Unknown error'}`;
}; 